import React from 'react';
import { drop } from 'lodash';

import { connect } from 'react-redux';
import AdUnit from './AdUnit';
import { getAdUnitPackage } from '../../util/adUtils';
//country: state.country,
const mapStateToProps = state => ({
  country: 'dk',
  breakpoint: state.events.breakpoint,
  routeParams: state.routeParams,
});

export default class TickerAdContainer2 extends React.PureComponent {

  componentDidMount() {

    const script = document.createElement("script");

    script.src = "https://www.tv3sport.dk/ticker/ticker.js";
    script.async = true;

    document.body.appendChild(script);

    
  }

  componentWillUnmount() {
  }

  
  render() {
    const {country, breakpoint} = this.props;
    const bcf_bg1 = require(`../../../assets/bcf_logo_neg1.png`);
    
    return (
   
	    <div id="T1" className="TickerNews" ><div className="ti_wrapper">
	    	<div className="ti_slide"><div className="ti_content">
	    	
<div className="ti_news">
<div id="banner">
<a href="https://boernecancerfonden.dk/styrke/?utm_source=tv3s&utm_medium=d2&utm_campaign=heroq1">
<div id="layer0" >
<div id="layer1" ><p id="layer1-inner">Børn med kræft har brug for os voksne</p></div>
<div id="layer2" ><p id="layer2-inner">Støt via Mobilepay til 858610</p></div>
<div id="layer3"></div>
<div id="layer4"></div>
<img src={bcf_bg1} alt="BCF" className="bcf_bg"/>
<div id="layer6"></div>
<div id="layer9"></div>
</div>
</a>
</div>
</div>


<div className="ti_news">
<div id="banner">
<a href="https://boernecancerfonden.dk/styrke/?utm_source=tv3s&utm_medium=d1&utm_campaign=heroq1">
<div id="layer0" >
<div id="layer1" ><p id="layer1-inner">Børn med kræft har brug for os voksne</p></div>
<div id="layer2" ><p id="layer2-inner">Sms BØRN til 1912 og støt med 100 kr.</p></div>
<div id="layer3"></div>
<div id="layer4"></div>
<img src={bcf_bg1} alt="BCF" className="bcf_bg"/>
<div id="layer6"></div>
<div id="layer9"></div>
</div>
</a>
</div>
</div>
<div className="ti_news">
<div id="banner">
<a href="https://boernecancerfonden.dk/styrke/?utm_source=tv3s&utm_medium=d2&utm_campaign=heroq1">
<div id="layer0" >
<div id="layer1" ><p id="layer1-inner">Børn med kræft har brug for os voksne</p></div>
<div id="layer2" ><p id="layer2-inner">Støt via Mobilepay til 858610</p></div>
<div id="layer3"></div>
<div id="layer4"></div>
<img src={bcf_bg1} alt="BCF" className="bcf_bg"/>
<div id="layer6"></div>
<div id="layer9"></div>
</div>
</a>
</div>
</div>
	    	
<div className="ti_news">
<div id="banner">
<a href="https://boernecancerfonden.dk/styrke/?utm_source=tv3s&utm_medium=d1&utm_campaign=heroq1">
<div id="layer0" >
<div id="layer1" ><p id="layer1-inner">Børn med kræft har brug for os voksne</p></div>
<div id="layer2" ><p id="layer2-inner">Sms BØRN til 1912 og støt med 100 kr.</p></div>
<div id="layer3"></div>
<div id="layer4"></div>
<img src={bcf_bg1} alt="BCF" className="bcf_bg"/>
<div id="layer6"></div>
<div id="layer9"></div>
</div>
</a>
</div>
</div>

<div className="ti_news">
<div id="banner">
<a href="https://boernecancerfonden.dk/styrke/?utm_source=tv3s&utm_medium=d2&utm_campaign=heroq1">
<div id="layer0" >
<div id="layer1" ><p id="layer1-inner">Børn med kræft har brug for os voksne</p></div>
<div id="layer2" ><p id="layer2-inner">Støt via Mobilepay til 858610</p></div>
<div id="layer3"></div>
<div id="layer4"></div>
<img src={bcf_bg1} alt="BCF" className="bcf_bg"/>
<div id="layer6"></div>
<div id="layer9"></div>
</div>
</a>
</div>
</div>
	    	
<div className="ti_news">
<div id="banner">
<a href="https://boernecancerfonden.dk/styrke/?utm_source=tv3s&utm_medium=d1&utm_campaign=heroq1">
<div id="layer0" >
<div id="layer1" ><p id="layer1-inner">Børn med kræft har brug for os voksne</p></div>
<div id="layer2" ><p id="layer2-inner">Sms BØRN til 1912 og støt med 100 kr.</p></div>
<div id="layer3"></div>
<div id="layer4"></div>
<img src={bcf_bg1} alt="BCF" className="bcf_bg"/>
<div id="layer6"></div>
<div id="layer9"></div>
</div>
</a>
</div>
</div>
	    	
	    	</div></div>
	    </div></div>
		   
    );
  }
}




// WEBPACK FOOTER //
// ./src/component/Ads/TickerAdContainer2.jsx